import { LitElement, css, html } from "lit";
//#region src/pd-box-view/PdBoxView.ts
/**
* A responsive grid container for displaying content in columns.
*
* @tagname pd-box-view
* @summary Responsive CSS Grid container with configurable columns.
*
* @slot - Default slot for grid items.
*
* @cssprop --pd-box-columns - Number of grid columns. Default: `4`.
* @cssprop --pd-box-min-width - Minimum width of each grid item. Default: `100px`.
* @cssprop --pd-box-gap - Gap between grid items. Default: `25px`.
*/
var PdBoxView = class extends LitElement {
	static {
		this.styles = [css`
      :host {
        display: grid;
        grid-template-columns: repeat(
          var(--pd-box-columns, 4),
          minmax(var(--pd-box-min-width, 100px), 1fr)
        );
        gap: var(--pd-box-gap, 25px);
      }
    `];
	}
	render() {
		return html` <slot></slot> `;
	}
};
//#endregion
export { PdBoxView };
